import { adminPrefix } from "../../constants";

export const pagesContentApi = {
  FETCH_PAGES_CONTENT: adminPrefix + "pages-content",
  UPDATE_PAGES_CONTENT: adminPrefix + "pages-content/update",
};